function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import useGiveawayStore from '@/stores/GiveawayStore';
import useChannelStore from '@/stores/ChannelStore';
import { AuthProviders, UserLevels } from '@/types/server';
import { useShallow } from 'zustand/react/shallow';
import { Checkbox, SimpleGrid, Text } from '@mantine/core';
import styles from './GiveawayEligibilityStep.module.scss';
import GiveawayCreateFooter from './GiveawayCreateFooter';
import useIntlMemo from '@/hooks/useIntlMemo';
import ErrorNotice from '../ErrorNotice';
function CheckboxCard(_param) {
    var title = _param.title, props = _object_without_properties(_param, [
        "title"
    ]);
    return /*#__PURE__*/ _jsxs(Checkbox.Card, _object_spread_props(_object_spread({
        className: styles.root,
        radius: "md"
    }, props), {
        children: [
            /*#__PURE__*/ _jsx(Checkbox.Indicator, {}),
            /*#__PURE__*/ _jsx(Text, {
                children: title
            })
        ]
    }));
}
function GiveawayUserEllibility(param) {
    var onBack = param.onBack, onNext = param.onNext;
    var intl = useIntl();
    var channel = useChannelStore(function(state) {
        return state.channel;
    });
    var _useGiveawayStore = useGiveawayStore(useShallow(function(state) {
        return {
            eligibility: state.eligibility,
            luck: state.luck,
            setLuck: state.setLuck,
            setEligibility: state.setEligibility,
            type: state.type
        };
    })), eligibility = _useGiveawayStore.eligibility, setEligibility = _useGiveawayStore.setEligibility;
    var subscriberCheckboxTitle = (channel === null || channel === void 0 ? void 0 : channel.provider) === AuthProviders.YOUTUBE ? intl.formatMessage({
        id: "/mYICv",
        defaultMessage: [
            {
                type: 0,
                value: "Channel Members"
            }
        ]
    }) : intl.formatMessage({
        id: "u4eb+l",
        defaultMessage: [
            {
                type: 0,
                value: "Subscribers"
            }
        ]
    });
    var error = useIntlMemo(function(intl) {
        if (eligibility.length === 0) {
            return intl.formatMessage({
                id: "7iFJ2v",
                defaultMessage: [
                    {
                        type: 0,
                        value: "At least one option must be selected."
                    }
                ]
            });
        }
        return null;
    }, [
        eligibility
    ]);
    return /*#__PURE__*/ _jsxs(React.Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Text, {
                className: styles.subHeading,
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "ge33oq",
                    defaultMessage: "Select who can participate in the giveaway."
                })
            }),
            /*#__PURE__*/ _jsx(Checkbox.Group, {
                value: eligibility,
                onChange: function(value) {
                    return setEligibility(value);
                },
                children: /*#__PURE__*/ _jsxs(SimpleGrid, {
                    cols: {
                        xs: 1,
                        md: 2
                    },
                    className: styles.grid,
                    spacing: "lg",
                    children: [
                        /*#__PURE__*/ _jsx(CheckboxCard, {
                            title: intl.formatMessage({
                                id: "37mth/",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Viewers"
                                    }
                                ]
                            }),
                            value: UserLevels.EVERYONE
                        }),
                        /*#__PURE__*/ _jsx(CheckboxCard, {
                            title: intl.formatMessage({
                                id: "o458GP",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Regulars"
                                    }
                                ]
                            }),
                            value: UserLevels.REGULAR
                        }),
                        (channel === null || channel === void 0 ? void 0 : channel.provider) === AuthProviders.TWITCH ? /*#__PURE__*/ _jsx(CheckboxCard, {
                            title: intl.formatMessage({
                                id: "g4byOr",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "VIPs"
                                    }
                                ]
                            }),
                            value: UserLevels.TWITCH_VIP
                        }) : null,
                        (channel === null || channel === void 0 ? void 0 : channel.provider) === AuthProviders.SOOP ? /*#__PURE__*/ _jsx(CheckboxCard, {
                            title: intl.formatMessage({
                                id: "g4byOr",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "VIPs"
                                    }
                                ]
                            }),
                            value: UserLevels.SOOP_VIP
                        }) : null,
                        /*#__PURE__*/ _jsx(CheckboxCard, {
                            title: subscriberCheckboxTitle,
                            value: UserLevels.SUBSCRIBER
                        }),
                        /*#__PURE__*/ _jsx(CheckboxCard, {
                            title: intl.formatMessage({
                                id: "qP6RWY",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Moderators"
                                    }
                                ]
                            }),
                            value: UserLevels.MODERATOR
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(GiveawayCreateFooter, {
                backButtonProps: {
                    onClick: onBack
                },
                nextButtonProps: {
                    disabled: eligibility.length === 0,
                    onClick: onNext
                },
                nextText: intl.formatMessage({
                    id: "9+Ddtu",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Next"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(ErrorNotice, {
                className: styles.error,
                children: error
            })
        ]
    });
}
export default GiveawayUserEllibility;
